import { render, staticRenderFns } from "./SignatureControl.vue?vue&type=template&id=4c9772b7&scoped=true"
import script from "./SignatureControl.vue?vue&type=script&lang=js"
export * from "./SignatureControl.vue?vue&type=script&lang=js"
import style0 from "./SignatureControl.vue?vue&type=style&index=0&id=4c9772b7&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c9772b7",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data01/test/dev.console.insureforce.cn/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4c9772b7')) {
      api.createRecord('4c9772b7', component.options)
    } else {
      api.reload('4c9772b7', component.options)
    }
    module.hot.accept("./SignatureControl.vue?vue&type=template&id=4c9772b7&scoped=true", function () {
      api.rerender('4c9772b7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/examine/auditManage/components/SignatureControl.vue"
export default component.exports